import { render, staticRenderFns } from "./VipCardSetting.vue?vue&type=template&id=e0445838"
import script from "./VipCardSetting.vue?vue&type=script&lang=js"
export * from "./VipCardSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports